import { createAction } from '@reduxjs/toolkit';

import { SetSearchTermPayload } from '../types/elevio.actions';

const prefix = 'elevio/search';

export const searchActions = {
  setInitialConversationSearchState: createAction<{
    conversationId: number;
  }>(`${prefix}/setInitialConversationSearchState`),
  setSearchTerm: createAction<SetSearchTermPayload>(`${prefix}/setSearchTerm`),
  initialiseInputValue: createAction<{ value: string }>(
    `${prefix}/initialiseInputValue`,
  ),
  setSearchInputValue: createAction<{ value: string; conversationId: number }>(
    `${prefix}/setSearchInputValue`,
  ),
  searchRequest: createAction<{ conversationId: number }>(
    `${prefix}/searchRequest`,
  ),
  searchSuccess: createAction(`${prefix}/searchSuccess`),
  searchFailure: createAction(`${prefix}/searchFailure`),
};
